<script setup lang="ts">
import { useUiStore, type Toast } from '@/stores'

const uiStore = useUiStore()

const icons = {
  success: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />`,
  error: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />`,
  warning: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />`,
  info: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />`,
}

const colors = {
  success: 'bg-green-50 text-green-800 dark:bg-green-900/50 dark:text-green-200',
  error: 'bg-red-50 text-red-800 dark:bg-red-900/50 dark:text-red-200',
  warning: 'bg-yellow-50 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-200',
  info: 'bg-blue-50 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200',
}

const iconColors = {
  success: 'text-green-500',
  error: 'text-red-500',
  warning: 'text-yellow-500',
  info: 'text-blue-500',
}
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed top-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none"
      aria-live="polite"
    >
      <TransitionGroup
        enter-active-class="transition-all duration-300"
        enter-from-class="opacity-0 translate-x-full"
        enter-to-class="opacity-100 translate-x-0"
        leave-active-class="transition-all duration-300"
        leave-from-class="opacity-100 translate-x-0"
        leave-to-class="opacity-0 translate-x-full"
      >
        <div
          v-for="toast in uiStore.toasts"
          :key="toast.id"
          :class="[
            'pointer-events-auto w-80 rounded-lg p-4 shadow-lg',
            colors[toast.type]
          ]"
          role="alert"
        >
          <div class="flex items-start gap-3">
            <svg
              :class="['h-5 w-5 flex-shrink-0', iconColors[toast.type]]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              v-html="icons[toast.type]"
            />

            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium">{{ toast.title }}</p>
              <p v-if="toast.message" class="mt-1 text-sm opacity-80">
                {{ toast.message }}
              </p>
            </div>

            <button
              type="button"
              class="flex-shrink-0 rounded p-1 hover:bg-black/10"
              @click="uiStore.removeToast(toast.id)"
            >
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
